<div class="flex justify-content-center" style="height: 300px">
  <ng-lottie [options]="lottieOptions"></ng-lottie>
</div>
<h3 class="p-text-secondary text-center">
  Este módulo está en desarrollo. Algunas funcionalidades pueden no estar
  disponibles
</h3>
